import { RouteObject } from "react-router";

import PageError from "@/shared/ui/errors/PageError";
import * as Sentry from "@sentry/react";

export const educationRoutes: RouteObject = {
	path: "/elearning/*",
	caseSensitive: false,
	children: [
		{
			index: true,
			lazy: async () => {
				const { EducationHome } = await import("./pages");
				return {
					Component: () => (
						<Sentry.ErrorBoundary
							fallback={({ error, componentStack, resetError }) => (
								<PageError
									error={error}
									componentStack={componentStack}
									reset={resetError}
								/>
							)}
						>
							<EducationHome />
						</Sentry.ErrorBoundary>
					),
				};
			},
		},
		{
			path: "courses",
			lazy: async () => {
				const { default: Courses } = await import("./pages/Courses");
				return {
					Component: Courses,
				};
			},
		},
		{
			path: "courses/:courseId",
			lazy: async () => {
				const { CourseDetails } = await import("./pages/CourseDetails");
				return {
					Component: CourseDetails,
				};
			},
		},
	],
};
